import { Permission, BuyerCustomerDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';

type SetCustomerParams = {
	customer: BuyerCustomerDTO;
	setCustomer: (customer: BuyerCustomerDTO) => Promise<void>;
	hideRemoveCustomerButton?: boolean;
	requiredPermission: Permission
};

async function setNewCustomer({ setCustomer }: SetCustomerParams): Promise<Result<BuyerCustomerDTO>> {
	const result = await Command.execute('searchCustomerByText');
	if (result.ok) {
		await setCustomer(result.value);
		return Result.ok(result.value);
	}

	return Result.error();
}

async function setOrRemoveCustomer(params: SetCustomerParams): Promise<Result<BuyerCustomerDTO>> {

	const newParams = {
		...params,
		setCustomer: async (customer: BuyerCustomerDTO) => {
			if (!Preconditions.ensure(params.requiredPermission)())
				return;

			await params.setCustomer(customer);
		}
	};

	const customer = params.customer;
	if (customer.Id === 0)
		return setNewCustomer(newParams);

	return Command.execute('showCustomerDetails', newParams);
}

declare global {
	interface CommandType {
		setOrRemoveCustomer: (params: SetCustomerParams) => Promise<Result<BuyerCustomerDTO>>
	}
}

Command.register('setOrRemoveCustomer', 'NO_PRECONDITION', setOrRemoveCustomer);

